import styled from 'styled-components';

export const Wrapper = styled.div`
  && {
    .section {
      padding: 25px 40px;
    }
    .list-patient {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 66px;
      background-color: #ecffb8;
      padding: 17px 25px 0px 60px;
      .btn-output {
        background-color: #a956ea;
        color: white;
        height: 35px;
        padding: 5px 50px;
        border-radius: 5px;
        border: none;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.25);
      }
      .wrap-export-button {
        display: flex;
        justify-content: center;
        align-items: center;
        .smallBoldFont {
          margin: 0 20px;
        }
      }
    }
    .table {
      margin-top: 40px;
    }
  }
`;
